import { TDocumentation } from 'src/modules/conversations/components/types';
import { IDocument } from 'src/interfaces/document';
import _ from 'lodash';

/**
 * Returns an updated list of documentation entries with the new document added or updated.
 *
 * This function ensures that the resulting array contains unique entries based on the `_id` field.
 * If a document with the same `_id` already exists, it will be replaced by the new one.
 *
 * @param documentation - The current list of documentation entries.
 * @param document - The document to be added or updated in the list.
 * @param t - Translation function used to localize the document name.
 * @returns A new array of documentation entries, with no duplicate `_id` values.
 */

export const addOrUpdateDocument = (
    documentation: TDocumentation[],
    document: IDocument,
    t: Function
): TDocumentation[] => {
    const newDocument: TDocumentation = {
        _id: document._id,
        name: t(`Documents.${document.title}`),
        file: document.file,
    };

    const mergedDocs = [...documentation, newDocument].reverse();
    const uniqueDocs = _.uniqBy(mergedDocs, '_id').reverse();

    return uniqueDocs;
};
